<template>
  <div class="view-container d-2304" :class="[sidePaddingClass]">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    /**
     * vuetify px helper class
     * 1 = 4px
     * 5 = 20px
     */
    px: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    sidePaddingClass() {
      return this.$vuetify.breakpoint.smAndUp ? `px-${this.px}` : 'px-3'
    },
  },
}
</script>

<style></style>
